const primeClicksDataIds = [
    'membership-discover-prime-payment',
    'membership-tc-popup',
    'add-prime-subscription-payment',
    'prime-fare-selected-prime-page',
    'full-fare-selected-prime-page',
    'selectable-radio-plus',
    'selectable-radio-basic',
    'selectable-radio-nonPrime',
    'voluntary-modification-three-month-free-trial-prime-acquisition',
];

const primeCatalog = new Set(primeClicksDataIds);

export default primeCatalog;
